import { LoadableLazy } from '@confluence/loadable';

import type { LargePageSplitCandidateDetectorProps as DetectorProps } from './LargePageSplitCandidateDetector.tsx';

export type LargePageSplitCandidateDetectorProps = DetectorProps;

export const LazyLargePageSplitCandidateDetector = LoadableLazy({
	name: 'LargePageSplitCandidateDetector',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LargePageSplitCandidateDetector" */ './LargePageSplitCandidateDetector.tsx'
			)
		).LargePageSplitCandidateDetector,
});
